import Vue from 'vue';
import Router from 'vue-router';
import Cookies from 'js-cookie';
import {
	getWxUserByCode,
	authRedirect
} from '@/api/h5';

// console.log(t.router, '===');

Vue.use(Router);

const routes = [{
		path: '/',
		component: () => import('@/view/index'),
		name: 'Index',
		meta: {
			title: '首页'
		}
	},
	{
		path: '/user',
		component: () => import('@/view/user/index'),
		name: 'user',
		meta: {
			title: '个人中心'
		}
	},
	{
		path: '/userList',
		component: () => import('@/view/user/list'),
		name: 'userList',
		meta: {
			title: '使用者列表'
		}
	},
	{
		path: '/userMemager',
		component: () => import('@/view/user/userMemager'),
		name: 'userMemager',
		meta: {
			title: '用户管理'
		}
	},
	{
		path: '/goods',
		component: () => import('@/view/goods/index'),
		name: 'goods',
		meta: {
			title: '积分兑换'
		}
	},
	{
		path: '/checkList',
		component: () => import('@/view/checkLIst'),
		name: 'checkList',
		meta: {
			title: '检测详情'
		}
	},
	{
		path: '/goodsList',
		component: () => import('@/view/goods/list'),
		name: 'goodsList',
		meta: {
			title: '兑换列表'
		}
	},
	{
		path: '/deviceBind',
		component: () => import('@/view/device/bindv2'),
		name: 'deviceBind',
		meta: {
			title: '绑定设备'
		}
	},
	// 二期绑定设备
	{
		path: '/device/bind',
		component: () => import('@/view/device/bindv2'),
		name: 'deviceBindNew',
		meta: {
			title: '新2绑定设备'
		}
	},
	{
		path: '/device',
		component: () => import('@/view/device/index'),
		name: 'device',
		meta: {
			title: '设备列表'
		}
	},
	{
		path: '/rent/list',
		component: () => import('@/view/rent/list'),
		name: 'rentList',
		meta: {
			title: '我的订单'
		}
	},
	{
		path: '/rent/detail',
		component: () => import('@/view/rent/detail'),
		name: 'rentDetail',
		meta: {
			title: '订单详情'
		}
	},
	{
		path: '/rent/change',
		component: () => import('@/view/rent/change'),
		name: 'rentChange',
		meta: {
			title: '更换设备'
		}
	},
	// /rentDevice
	{
		path: '/rentDevice',
		component: () => import('@/view/rent/rentDevice'),
		name: 'rentDevice',
		meta: {
			title: '租赁设备'
		}
	},
	{
		path: '/deviceDetail',
		component: () => import('@/view/device/detail'),
		name: 'deviceDetail',
		meta: {
			title: '设备信息'
		}
	},

	{
		path: '/rent/pay/test',
		component: () => import('@/view/rent/paytest'),
		name: 'paytest',
		meta: {
			title: '支付测试'
		}
	},
	{
		path: '/family/list',
		component: () => import('@/view/family/list'),
		name: 'familyList',
		meta: {
			title: '家庭管理'
		}
	},	
	{
		path: '/family/memberInfo',
		component: () => import('@/view/family/memberInfo'),
		name: 'familyMemberInfo',
		meta: {
			title: '成员信息'
		}
	},
	{
		path: '/family/manage',
		component: () => import('@/view/family/manage'),
		name: 'familyManage',
		meta: {
			title: '管理家庭'
		}
	},
	{
		path: '/family/setRemarks',
		component: () => import('@/view/family/setRemarks'),
		name: 'setRemarks',
		meta: {
			title: '设置备注'
		}
	},
	{
		path: '/family/join',
		component: () => import('@/view/family/join'),
		name: 'joinFamily',
		meta: {
			title: '加入家庭'
		}
	},
	{
		path: '/family/share',
		component: () => import('@/view/family/share'),
		name: 'shareFamily',
		meta: {
			title: '邀请家人',
			isShare: true
		},
		beforeEnter: (to, from, next) => {
			// let userAgent = navigator.userAgent
			// if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
			//   sessionStorage.setItem('originUrl', location.href)  // 用于ios分享
			// }  
			next()
		}
	}
];

const router = new Router({
	routes,
	mode: 'history'
});

function delCodeandstate(to) { //函数作用：去除url中的code和state
	let path = to.path
	let query = ""
	for (let i in to.query) {
		if (i != "code" && i != "state") {
			query = query + "&" + i + "=" + to.query[i]
		}
	}
	query = query == "" ? "" : "?" + query.substring(1, query.length)
	return path + query;
}

router.beforeEach((to, from, next) => {
	document.title = '欧欧眼保仪';
	console.log(to, '-----1')
	let fullPath = to.fullPath
	if (to.fullPath.includes("code")) { //判断url中是否有code，踩坑1-页面反复跳转
		fullPath = delCodeandstate(to)
	}
	const domian = window.location.origin //
	const redirect_uri = encodeURIComponent(domian + fullPath);
	const appid = "wxaa0a17cc6abc08a3" //redirect_uri，授权登陆后的回调地址，需要进行encodeURIComponent处理
	const code = to.query.code,
		state = to.query.state
	const isCur = process.env.NODE_ENV === 'development';

	const token = sessionStorage.getItem("token") //noLoginArr，白名单，不需要授权登陆的页面  
	if (isCur) { // 微信授权开关
		// sessionStorage.setItem("token", 'Bearer b8a1433be696495db90a055352482560'); // 调试
		// sessionStorage.setItem("token", 'Bearer 32db58d39ce54c29888cf8e4b4acc644')
		sessionStorage.setItem("token", 'Bearer 909da997162a4ab9b3c6a7c45e415a2a')
		next();
	} else {
		if (!token) { //登陆之后获取到code，传到后台登录
			// code && state &&
			let data = {
				code: code,
				type: 31,
				state
			}
			if (code && state) { // code 参数 不存在
				getWxUserByCode(data).then((res) => {
					console.log('wxAuth res====>', res);
					if (res) {
						sessionStorage.setItem("token", 'Bearer ' + res.accessToken);
						sessionStorage.setItem("openid", res.openid);
						console.log('wxAuth');
						to.query.code = undefined;
						to.query.state = undefined;
						next({
							...to,
							replace: true
						});
					} else {
						console.log(to.fullPath, delCodeandstate(fullPath), '===');
						console.log(fullPath, delCodeandstate(fullPath), '===');
						// window.location.href = domian + delCodeandstate(fullPath);
						next(false);
					}
				}).catch(function(error) {
					console.log(to.fullPath, delCodeandstate(fullPath), '===');
					console.log(fullPath, delCodeandstate(fullPath), '===');
					next(false);
					console.log(error, 'wxAuth error =====');
				});
			} else {
				const redirectUri = (to.name === 'deviceBind' || to.name === 'paytest' || to.name === 'rentDevice' || to.name === 'rentList' || to.name === 'joinFamily') ? redirect_uri : domian
					console.log(redirectUri, '--- redirect_uri ---');
				authRedirect({
					type: 31,
					redirectUri
				}).then(r => {
					console.log(r, 'redirect_uri');
					window.location.href = r;
				})
			}
		} else {
			next();
		}
	}
});

export {
	router
};